import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Hall from './hall';

export default class BoothPreview extends ReactFireComponent {
  constructor(props) {
    super(props);
    this.state = {
      booth: null
    }
  }
  componentDidMount() {
    this.bindAsObject(`/expos/${this.props.expoID}/booths/${this.props.boothID}`, 'booth');
  }
  componentWillUnmount() {
    this.unbind('booth');
  }
  render() {
    if(!this.state.booth) return null;

    var hall = {
      id: 'mock',
      stage: {
        width: 1554,
        height: 814,
        layers: [
          {
            'type': 'image',
            'image': '/preview-assets/hall-background.png',
            'x': 0,
            'y': 0,
            'order': 0
          },
          { 'type': 'content', 'order': 1 }
        ]
      },
      booths: [
        {
          'id': 0,
          'icon': '/preview-assets/sb00.png',
          'scale': '1.0',
          'x': 0,
          'y': 150
        },
        {
          'id': 1,
          'icon': '/preview-assets/sb05.png',
          'scale': '1.0',
          'x': 530,
          'y': 0
        },
        {
          'id': 2,
          'icon': '/preview-assets/sb06.png',
          'scale': '1.0',
          'x': 1050,
          'y': 120
        },
        {
          'id': 3,
          'icon': '/preview-assets/sb11.png',
          'scale': '1.0',
          'x': 10,
          'y': 450
        },
        {
          'id': 4,
          'icon': '/preview-assets/sb02.png',
          'scale': '1.0',
          'x': 1000,
          'y': 460
        },
        {
          'id': 5,
          'icon': this.state.booth.metadata.icon,
          'scale': 0.60,
          'x': 500,
          'y': 430,
          'boothURL': `/expos/${this.props.expoID}/booths/${this.props.boothID}/contents`
        }
      ]
    }

    return <Hall {...hall} />
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/booth-preview.js